/**
 * Determines if a keyboard event should be ignored based on the focused element type.
 *
 * Strategy:
 * - Text-like inputs (text, email, password, number, textarea, contenteditable): Always block all shortcuts
 * - Checkboxes, radios, and other non-text inputs: Always allow alphanumeric shortcuts
 *
 * @param event - The keyboard event
 * @returns true if the shortcut should be ignored, false otherwise
 */
export const shouldIgnoreKeyboardShortcut = (event: KeyboardEvent): boolean => {
  const target = event.target;

  if (!target || !(target instanceof HTMLElement)) {
    return false;
  }

  if (
    target.matches(
      'input[type="checkbox"], input[type="radio"], input[type="range"], input[type="button"], input[type="submit"], input[type="reset"]',
    )
  ) {
    return !/^[a-zA-Z0-9]$/.test(event.key);
  }

  if (
    target.matches('input') ||
    target.matches('select') ||
    target.matches('textarea') ||
    target.hasAttribute('contenteditable') ||
    target.closest('[contenteditable="true"]') ||
    target.closest('[contenteditable]')
  ) {
    return true;
  }

  return false;
};
